export default {
    api:{
        endpoint: process.env.NODE_ENV === "development" ? "http://192.168.0.188:8080" : "https://www.haoping.fun/api"
    },
    isProd: process.env.NODE_ENV !== "development"
}
